<ag-grid-angular class="relationship-grid" [class.ag-theme-alpine]="!dark" [class.ag-theme-alpine-dark]="dark"
  [rowData]="rows" [columnDefs]="columns" [defaultColDef]="defaultColumn" [rowHeight]="40" [headerHeight]="38"
  [loading]="loading" (rowClicked)="openRow($event)" (cellKeyDown)="openWithKeyboard($event)">
</ag-grid-angular>
